import React, { memo } from 'react';
import BaseModal from '../BaseModal/BaseModal';

import './ConfirmSlotModal.scss';

const ConfirmSlotModal = ({ professional, facility, shiftDetails, shiftType, unit, onClose, onConfirm }) => (
	<BaseModal
		className="confirm-slot-modal"
		title="Confirm professional for this shift?"
		primaryActionLabel="Confirm"
		onPrimaryAction={onConfirm}
		secondaryActionLabel="Cancel"
		onSecondaryAction={onClose}
		onHide={onClose}
	>
		<div className="confirm-slot-modal__container">
			<div className="confirm-slot-modal__row">
				Professional:<span> {professional}</span>
			</div>
			<div className="confirm-slot-modal__row">
				Facility:<span> {facility}</span>
			</div>
			<div className="confirm-slot-modal__row">
				Shift details:<span> {shiftDetails}</span>
			</div>
			<div className="confirm-slot-modal__row">
				Shift type:<span> {shiftType}</span>
			</div>
			<div className="confirm-slot-modal__row">
				Unit:<span> {unit || '-'}</span>
			</div>
		</div>
	</BaseModal>
);

export default memo(ConfirmSlotModal);
